export { EloZoomOut } from './zoom-out-icon'
